// extracted by mini-css-extract-plugin
module.exports = {"purple":"#7349cc","button":"Button-module--button--2X_Ir","focusVisible":"Button-module--focus-visible--1K7Ub"};